import { useState } from 'react';

const PLACEHOLDER_BASE = 'https://short.example.com';

/**
 * 短網址生成器（帶分析）：UI 先完成，實際縮網址需接後端 KV API
 */
export function ShortUrlTool() {
  const [longUrl, setLongUrl] = useState('');
  const [shortCode, setShortCode] = useState('');
  const [created, setCreated] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!longUrl.trim()) return;
    // 後端未接：僅模擬顯示短網址
    const code = shortCode.trim() || Math.random().toString(36).slice(2, 10);
    setCreated(`${PLACEHOLDER_BASE}/${code}`);
  };

  return (
    <>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              原始網址
            </label>
            <input
              type="url"
              value={longUrl}
              onChange={e => setLongUrl(e.target.value)}
              placeholder="https://..."
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              自訂短碼（選填）
            </label>
            <input
              type="text"
              value={shortCode}
              onChange={e =>
                setShortCode(e.target.value.replace(/[^a-zA-Z0-9_-]/g, ''))
              }
              placeholder="例如：promo2024"
              className="w-full rounded border border-gray-300 bg-white px-3 py-2 font-mono text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            />
          </div>
          <button
            type="submit"
            className="rounded bg-primary px-4 py-2 text-white hover:bg-primary/90"
          >
            產生短網址
          </button>
        </form>
      </div>

      {created && (
        <div className="mb-6 rounded-lg border border-green-200 bg-green-50 p-6 dark:border-green-800 dark:bg-green-900/20">
          <p className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            短網址
          </p>
          <p className="font-mono text-primary break-all">{created}</p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            點擊分析功能需接後端 Cloudflare Workers KV 後啟用。
          </p>
        </div>
      )}

      <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-sm font-medium text-gray-700 dark:text-gray-300">
          點擊分析
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          串接後端 KV
          後可顯示：總點擊數、來源、裝置、時間分布等。目前為預留介面。
        </p>
      </div>

      <section className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
        <h2 className="mb-3 text-lg font-semibold text-gray-900 dark:text-gray-100">
          使用說明
        </h2>
        <p className="leading-relaxed text-gray-600 dark:text-gray-400">
          輸入長網址即可產生短網址，可自訂短碼。實際縮址與點擊統計需由後端
          Cloudflare Workers KV 提供，速度極快，適合行銷活動追蹤。
        </p>
      </section>
    </>
  );
}
